/** @jsx jsx */
import * as _ from 'lodash'
import { jsx } from '@emotion/core'
import { Button } from '@styles/button.style'
import { observer } from 'mobx-react'
import React, { Fragment } from 'react'
import { isMobile } from 'react-device-detect'
import useRootStore from '@store/useRootStore'
import * as Utils from '@utils/utils'
import { MatchTrack, TournamentTrack } from '@store/matchupStore'
import { PAGE_TYPE } from '@interface/common'
import { useOnMount } from '@utils/reactExt'
import { GAME_TYPE } from '@game-type/game-market-types'
import { LS_MATCH_STATUS, MATCH_STATUS } from 'adv-protocol/src/GameCommon'
import { GlobalStoreKey } from '@v2/constants/common'
import { PickIco } from '@shared/Icon/MatchupIcon'
import SportTalkIco from '@shared/Icon/MatchupIcon/SportTalkIco'
import { BadgeStyle } from '@styles/base.style'
import { Badge } from 'antd-mobile'
import { MATCHUP_DETAIL_CONTENT_TAB_KEY } from '@constants/index'
import Login from '@views/Login'
import StorageUtils from '@utils/storage-utils'

interface MatchUpButtonProps {
  matchIndex: number
  rowIndex: string
  pageType?: PAGE_TYPE
  track: TournamentTrack
  match: MatchTrack
  tournamentId: number
  onFieldClickCheck: () => boolean
  showMatchupDetail: () => void
  isDetail?: boolean
  isStatVisualization?: boolean
  isCheerForTeam?: boolean
  isPick?: boolean
}

const MatchUpButton: React.FC<MatchUpButtonProps> = (props: MatchUpButtonProps) => {
  const { matchupStore, globalStore, logStore, authStore } = useRootStore()
  const { onFieldClickCheck, tournamentId, match, pageType, rowIndex, matchIndex, track, showMatchupDetail } = props
  const {
    irregularCount,
    matchStatusCode,
    matchId,
    isVisible,
    dateOfMatch,
    userPickCount = 0,
    companyPickCount = false,
    cheerForTeamCount = 0,
  } = match
  const detailOddsCount = irregularCount
  // const detailOddsCount = _.size(irregulars)
  const { producerId, detailTrack, club, currentGameKey } = matchupStore
  const { isSignedIn } = authStore
  const {
    isDetail = false,
    // isStatVisualization = false,
    isPick = false,
    isCheerForTeam = false,
  } = props

  // img
  const imageUrl = globalStore.findGlobalSetting(GlobalStoreKey.INGAME_IMAGES_URL).value

  let MatchMoreBtnImg: string
  let MatchMoreBtnArrowImg: string
  let buttonClassName = 'odds-block-list--btn detail'
  const selectedMatchId = detailTrack?.track?.matchId || undefined

  if (!_.isNil(selectedMatchId) && selectedMatchId === matchId && !isMobile) {
    buttonClassName = `odds-block-list--btn detail pc focus`
    MatchMoreBtnArrowImg = `${imageUrl}btn/match_more_btn_arrow_active.png`
    MatchMoreBtnImg = `${imageUrl}btn/match_more_btn_bg_active.png`
  } else {
    MatchMoreBtnArrowImg = `${imageUrl}btn/match_more_btn_arrow.png`
    MatchMoreBtnImg = `${imageUrl}btn/match_more_btn_bg.png`
  }

  let MatchUpBtnBgImg
  if (pageType === PAGE_TYPE.MATCHUP_RESULT || pageType === PAGE_TYPE.MATCHUP_RESULT_FILTER) {
    MatchUpBtnBgImg = `${imageUrl}btn/match_up_btn_bg_gray.png`
  } else {
    MatchUpBtnBgImg = `${imageUrl}btn/match_up_btn_bg.png`
  }

  const isActive = () => {
    if (pageType === PAGE_TYPE.MATCHUP_RESULT || pageType === PAGE_TYPE.MATCHUP_RESULT_FILTER) {
      return false
    }
    if (detailOddsCount <= 0) {
      return false
    }
    if (!isVisible) {
      // 오즈메이커 개시 중지 여부
      return false
    }

    if (Utils.isLsportsEnv()) {
      switch (matchStatusCode) {
        case LS_MATCH_STATUS.ABANDONED:
        case LS_MATCH_STATUS.COVERAGE_LOST:
        case LS_MATCH_STATUS.FULL_TIME:
        case LS_MATCH_STATUS.FULL_TIME_AFTER_OVERTIME:
        case LS_MATCH_STATUS.FULL_TIME_AFTER_PENALTIES:
          return false
      }
    }

    /**
     * Abandoned = 90,
     * Walkover = 91,
     * Retired = 92,
     * Walkover_Player1Won = 93,
     * Walkover_Player2Won = 94,
     * Player1Retired_Player2Won = 95,
     * Player2Retired_Player1Won = 96,
     * Player1Defaulted_Player2Won = 97,
     * Player2Defaulted_Player1Won = 98,
     * OnlyResult = 99,
     * Ended = 100,
     * AET = 110,
     * AOT = 111, After OverTime
     * AP = 120, After Penalties
     */
    if (!Utils.isLsportsEnv()
      && (matchStatusCode >= MATCH_STATUS.Abandoned && matchStatusCode <= MATCH_STATUS.Ended)
    ) {
      return false
    }
    return true
  }

  useOnMount(() => {
    // let manualSettingDetailTrack
    if (!isMobile && !detailTrack && rowIndex === '0' && matchIndex === 1) {
      if (isActive()) {
        matchupStore.fetchMatchupDetailMarkets({
          gameType: matchupStore.gameKey, clubId: club?.id, producerId, matchId, tournamentId,
        }).catch(console.error)
        // manualSettingDetailTrack = matchupStore.setDetailTrack(tournamentId, match, pageType)
      } else if (pageType === PAGE_TYPE.MATCHUP_RESULT || pageType === PAGE_TYPE.MATCHUP_RESULT_FILTER) {
        matchupStore.setDetailTrack(tournamentId, match, pageType)
      }
    }
  })

  // pc --> 활성화된 상세경기 표시 className: 'focus'
  const getSelectedClassName = (): string => {
    if (isMobile) {
      return ''
    }

    if (globalStore.visibleGuide) {
      return ''
    }

    // if (!_.isNil(selectedMatchId) && selectedMatchId === matchId) {
    //   return 'focus'
    // }
    return ''
  }

  const onClickDetail = async (contentTabKey: MATCHUP_DETAIL_CONTENT_TAB_KEY) => {
    switch (currentGameKey) {
      case GAME_TYPE.CROSS:
        logStore.writeButtonLog({ pageId: 'b010', buttonId: '009' }).catch(console.error)
        break
      case GAME_TYPE.LIVE:
        logStore.writeButtonLog({ pageId: 'b020', buttonId: '007' }).catch(console.error)
        break
    }

    globalStore.setVisibleGuide(false)
    if (onFieldClickCheck) {
      const conti = onFieldClickCheck()
      if (conti === false) {
        return
      }
    }

    if (contentTabKey === MATCHUP_DETAIL_CONTENT_TAB_KEY.PICK) {
      if (!isSignedIn) {
        authStore.showLoginPopup(<Login/>)
        return
      }
      StorageUtils.saveUserPickPromotionBannerHide()
    }

    const dateInst = new Date(dateOfMatch)

    if (pageType !== PAGE_TYPE.MATCHUP_RESULT && pageType !== PAGE_TYPE.MATCHUP_RESULT_FILTER
      && currentGameKey === GAME_TYPE.CROSS && dateInst <= new Date()) {
      globalStore.resetGeneralPopupProperties()
      matchupStore.clearCart()

      Utils.showToast(Utils.TOAST_TYPE.WARN, '베팅 마감 시간이 초과되었습니다.')

      const hashParameters = Utils.getAttachableHashParameters(true)
      Utils.reloadPage(`matchup/cross/${Utils.getInitializeClubId()}${hashParameters}`)
      return
    }

    matchupStore.setMatchupDetailContentTabKey(contentTabKey)
    if (getSelectedClassName() === 'focus' && contentTabKey === MATCHUP_DETAIL_CONTENT_TAB_KEY.BET) {
      await matchupStore.fetchMatchupDetailMarkets({
        gameType: matchupStore.gameKey, clubId: club?.id, producerId, matchId, tournamentId: track.tournamentId,
      })
    } else {
      showMatchupDetail()
    }
  }


  let subButtonClassName = 'odds-block-list--btn sub-btn'
  if (pageType === PAGE_TYPE.MATCHUP_RESULT || pageType === PAGE_TYPE.MATCHUP_RESULT_FILTER) {
    subButtonClassName = 'odds-block-list--btn sub-btn result-page'
  }

  const pickCount = _.toNumber(userPickCount) + _.toNumber(companyPickCount)
  return (
    <Fragment>
      {isDetail &&
        <Button TP className={buttonClassName} onClick={() => {
          onClickDetail(MATCHUP_DETAIL_CONTENT_TAB_KEY.BET).catch(console.error)
        }}>
          {/*{isMobile? <img src={MatchMoreBtnMobileImg} alt="상세 bet" className="odds-block-list--btn--img" /> : <img src={MatchMoreBtnPCImg} alt="상세 bet" className="odds-block-list--btn--img pc" />}*/}
          <span className="odds-block-list--btn--txt">
            <img src={MatchMoreBtnImg} alt="상세 bet" className="odds-block-list--btn--img"/>
            {detailOddsCount}
            <img src={MatchMoreBtnArrowImg} alt="상세 bet" className="odds-block-list--btn--img arrow"/>
          </span>
        </Button>
      }

      {/* 기획 변경으로 매치정보 버튼 출력 중단 */}
      {/*{isStatVisualization &&*/}
      {/*  <Button className={subButtonClassName} onClick={() => {*/}
      {/*    onClickDetail(MATCHUP_DETAIL_CONTENT_TAB_KEY.MATCH).catch(console.error)*/}
      {/*  }}>*/}
      {/*    <img src={MatchUpBtnBgImg} alt="매치정보" className="btn-bg"/>*/}
      {/*    <VisualIco/>*/}
      {/*  </Button>*/}
      {/*}*/}

      {isPick &&
        <Button className="pick-btn sub-btn" onClick={() => {
          onClickDetail(MATCHUP_DETAIL_CONTENT_TAB_KEY.PICK).catch(console.error)
        }}>
          <img src={MatchUpBtnBgImg} alt="분석글" className="btn-bg"/>
          <PickIco/>
          <Badge
            text={pickCount}
            overflowCount={99}
            css={BadgeStyle}
            className="pick-badge"
          />
        </Button>
      }

      {isCheerForTeam &&
        <Button className={subButtonClassName}
                onClick={() => {
                  onClickDetail(MATCHUP_DETAIL_CONTENT_TAB_KEY.SPORT_TALK).catch(console.error)
                }}>
          <img src={MatchUpBtnBgImg} alt="스포츠톡" className="btn-bg"/>
          <SportTalkIco/>
          <Badge
            text={cheerForTeamCount}
            overflowCount={99}
            css={BadgeStyle}
            className="pick-badge"
          />
        </Button>
      }
    </Fragment>
  )
}

export default observer(MatchUpButton)
